var React = require('react');

function RemoveCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.25 13.7493L13.75 6.24927","stroke":"#32213A","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.75 13.7493L6.25 6.24927","stroke":"#32213A","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10 18.6243C14.7635 18.6243 18.625 14.7627 18.625 9.99927C18.625 5.23581 14.7635 1.37427 10 1.37427C5.23654 1.37427 1.375 5.23581 1.375 9.99927C1.375 14.7627 5.23654 18.6243 10 18.6243Z","stroke":"#32213A","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

RemoveCircle.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = RemoveCircle;

RemoveCircle.default = RemoveCircle;
